import { useContext, useEffect, useState } from "react";
import useSinglePortalUser from "../useSinglePortalUser";
import { ApplicationState } from "../../../context/ApplicationStateContext";
import useProfile from "../useProfile";

function useEnableLOMN() {
  const [showCheckbox, setshowCheckbox] = useState(false);
  const { data: profile } = useProfile();
  const {
    state: { selectedPhysician: physicianId, selectedOrganization },
  } = useContext(ApplicationState);
  const { data, isLoading, isFetching } = useSinglePortalUser(
    physicianId ? physicianId?.toString() : ""
  );

  function handleEsignatureChecks(selectedPhysician: any) {
    if (selectedPhysician?.sofs?.length > 0) {
      setshowCheckbox(false);
    } else setshowCheckbox(true);
  }

  function determineDualRole(selectedPhysician: any) {
    let foundOrganization = null;
    let physicianOrganizationRoles = !!selectedPhysician?.organizationRoles
      ? selectedPhysician?.organizationRoles
      : !!selectedPhysician?.organizationRoles
      ? selectedPhysician?.organizationRoles
      : null;

    if (physicianOrganizationRoles) {
      if (typeof physicianOrganizationRoles === "string")
        foundOrganization = JSON?.parse(physicianOrganizationRoles)[
          selectedOrganization ? selectedOrganization : ""
        ];
      else
        foundOrganization =
          physicianOrganizationRoles[
            selectedOrganization ? selectedOrganization : ""
          ];
    }

    if (
      foundOrganization &&
      foundOrganization?.roles?.includes("Physician") &&
      selectedPhysician?.id === profile?.user?.id
    ) {
      setshowCheckbox(false);
    } else {
      handleEsignatureChecks(selectedPhysician);
    }
  }

  useEffect(() => {
    if (!isFetching && data?.data.user) {
      determineDualRole(data?.data?.user);
    }
  }, [physicianId, isFetching]);

  return { showCheckbox, isFetching };
}

export default useEnableLOMN;
